import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { Link } from 'react-router-dom';
export function Hero() {
  const [videoError, setVideoError] = useState(false);
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden bg-[#0B1014]" data-id="element-370">
      {/* Background Video/Image */}
      <div className="absolute inset-0 z-0" data-id="element-371">
        <div className="absolute inset-0 bg-gradient-to-b from-[#0B1014]/70 via-transparent to-[#0B1014] z-10" data-id="element-372" />
        {!videoError ? <video autoPlay loop muted playsInline onError={() => setVideoError(true)} className="w-full h-full object-cover opacity-60" data-id="element-373">
            <source src="https://assets.mixkit.co/videos/preview/mixkit-people-dancing-in-a-nightclub-with-colored-lights-42529-large.mp4" type="video/mp4" data-id="element-374" />
          </video> : <img src="https://images.unsplash.com/photo-1566737236500-c8ac43014a67?q=80&w=2070&auto=format&fit=crop" alt="Restaurant and Lounge" className="w-full h-full object-cover opacity-60" data-id="element-375" />}
      </div>

      {/* Content */}
      <div className="relative z-20 text-center px-4 max-w-4xl mx-auto" data-id="element-376">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} data-id="element-377">
          <img src="https://cdn.magicpatterns.com/uploads/pkCge4WeKF7gnZEZgQvaMG/HOF-mail-logo-white.png" alt="House of Flavors" className="w-96 md:w-[650px] mx-auto mb-1" data-id="element-378" />
          <p className="text-2xl md:text-4xl text-white tracking-[0.2em] uppercase mb-2 font-bold" data-id="element-379">
            House of Flavors
          </p>
          <p className="text-xl md:text-2xl text-white tracking-[0.3em] uppercase mb-12 font-light" data-id="element-380">
            Theatre of Dreams
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} className="flex flex-col md:flex-row items-center justify-center gap-6" data-id="element-381">
          <Link to="/bottle-service" data-id="element-382">
            <Button size="lg" className="min-w-[200px]" data-id="element-383">
              BUY TICKETS & TABLES
            </Button>
          </Link>
          <Link to="/events" data-id="element-384">
            <Button variant="outline" size="lg" className="min-w-[200px]" data-id="element-385">
              VIEW CALENDAR
            </Button>
          </Link>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-10 left-1/2 transform -translate-x-1/2 z-20" data-id="element-386">
        <div className="w-[1px] h-24 bg-gradient-to-b from-transparent via-[#DDA247] to-transparent animate-pulse" data-id="element-387" />
      </motion.div>
    </section>;
}